export const pulsingMarkdownLink = 'PULSING';
export const pulsingMarkdownLinkHash = `#${pulsingMarkdownLink}`;
export const dataIdMap = {
  alert: 'data-alert',
  alertContent: 'data-alert-content',
  alertType: 'data-alert-type',
  citationIndex: 'data-citation-index',
  code: 'data-code', // the code inside the code block (faster than parsing from children)
  draftContent: 'data-draft-content',
  isMessageStreaming: 'data-is-message-streaming',
  isNodeStreaming: 'data-is-node-streaming',
  messageId: 'data-message-id',
  suggestionIds: 'data-suggestion-ids',
  tableMarkdown: 'data-table-markdown', // the original markdown source for tables
  threadId: 'data-thread-id',
  title: 'data-alert-title',
};
